module.exports = __webpack_public_path__ + "img/box-6.3f824ca1.png";